import React, { Component } from 'react';

class CenterActivitis extends Component {

    render() { 
        return ( 
            <div>
                
            </div>
         );
    }
}
 
export default CenterActivitis;